<template>
  <div class="materialBinderList" v-if="auth.list">
    <el-form ref="searchForm" :model="search" size="mini" :inline="true" :label-position="position">
      <el-form-item>
        <el-input v-model="search.code" placeholder="物料小码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="search.imie" placeholder="识别码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="search.state" @clear="isEnabledClear" clearable placeholder="是否启用">
          <el-option v-for="item in status"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searcherSubmit">查询</el-button>
        <el-button type="primary" @click="addNew">新增</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="2">
      <el-col :xs="10">
        <el-table :data="bindingList" style="width: 100%;" border :fit="true"
                  :header-cell-style="{'text-align':'center'}"
                  :row-class-name="tableRowClassName">
          <el-table-column prop="materialName" label="物料名称" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="categoryName" label="品类" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="modelName" label="型号" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="code" label="小码" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="imie" label="识别号" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="state" label="状态" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state==1? 'success':'info'" disable-transitions>
                {{scope.row.state==1?'启用':'停止'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建者" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column fixed="right" min-width="150" label="操作" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-button v-show="scope.row.state==1" size="mini" @click="isEnabled(scope.row,scope.$index ,0)"
                         type="info">禁用
              </el-button>
              <el-button v-show="scope.row.state==0" size="mini" @click="isEnabled(scope.row,scope.$index ,1)"
                         type="success">启动
              </el-button>
              <el-button type='primary' size="mini" @click="edit(scope.row,scope.$index )">编辑</el-button>
              <el-button size="mini" type="danger" @click="remove(scope.row,scope.$index )">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination align='left'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pages.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pages.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pages.total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="绑定信息" :visible.sync="dialogFormVisible" center :before-close="handleClose">
      <el-form :model="binderInfoDate" :hide-required-asterisk="false" label-width="auto" size="small"
               :label-position="position" center>
        <el-row>
          <el-col :span="8">
            <el-form-item label="品牌">
              <el-select clearable disabled v-model="binderInfoDate.brandId" placeholder="品牌" @change="choseBrand">
                <el-option
                  v-for="(item,index) in brandList"
                  :key="index"
                  :label="item.brandName"
                  :value="item.brandId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品类">
              <el-select clearable disabled v-model="binderInfoDate.categoryId" placeholder="品类"
                         @change="choseCategory">
                <el-option
                  v-for="(item,index) in categoryList"
                  :key="index"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="型号">
              <el-select clearable disabled v-model="binderInfoDate.modelId" placeholder="型号" @change="choseModel">
                <el-option
                  v-for="(item,index) in modelList"
                  :key="index"
                  :label="item.modelName"
                  :value="item.modelId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="物料">
              <el-select clearable disabled filterable v-model="binderInfoDate.materialId" placeholder="物料"
                         @change="choseMaterial">
                <el-option
                  v-for="(item,index) in materialFormList"
                  :key="index"
                  :label="item.materialName"
                  :value="item.materialCoding"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item required label="小码">
              <el-input v-model="binderInfoDate.code" :disabled="!addnew" style="width: 87%;" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item required label="识别码">
              <el-input required v-model="binderInfoDate.imie" style="width: 87%;" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="启用">
              <el-select v-model="binderInfoDate.state" @clear="isEnabledClear" clearable placeholder="是否启用">
                <el-option v-for="item in status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="binderInfoDate.memo" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    addMaterialBinding,
    deleteBinding,
    getBinderAll,
    getBinderInfo,
    selectAllBrand,
    selectCategory,
    selectMaterialManagements,
    selectModel,
    updateBinding
  } from '../../api/api'
  import {getPermission} from "../../api/authRequest";
  import {hideLoading, showLoading} from "../../components/loading/loading";

  export default {
    components: {},

    data() {
      return {
        auth: {
          list: false,
        },
        search: {
          id: null,
          materialId: null,
          materialName: null,
          modelId: null,
          modelName: null,
          categoryId: null,
          categoryName: null,
          code: null,
          imie: null,
          state: null,
        },
        position: 'left',
        status: [{value: 1, label: "启用"}, {value: 0, label: "禁用"}],
        bindingList: [],
        pages: {
          page: 1,
          pageSize: 10,
          total: 0
        },
        dialogFormVisible: false,
        binderInfoDate: {},
        brandList: [], //品牌数组
        categoryList: [], //品类数组
        modelList: [], //型号数组
        materialFormList: [],
        addnew: false,
      }
    },
    mounted() {
      this.auth.list = getPermission('/api/binding/getBinderAll');
      this.getListAll();
      this.getBrandList(); //请求机型品牌数据
    },
    methods: {
      //清空是否启用
      isEnabledClear() {
        let _self = this;
        _self.search.isEnabled = null;
      },
      //表格颜色
      tableRowClassName({row, index}) {
        if (row.state == 1) {
          return 'success-row'
        } else {
          return 'warning-row'
        }
      },
      //检索
      searcherSubmit() {
        let _self = this;
        _self.getListAll();
      },
      //新增
      addNew() {
        let _self = this;
        _self.binderInfoDate = {};
        _self.addnew = true;
        _self.dialogFormVisible = true;
      },
      //编辑
      edit(row, index) {
        let _self = this;
        _self.search = {};
        _self.search.id = row.id;
        _self.getBinderInfo();
        _self.addnew = false;
        _self.dialogFormVisible = true
      },
      isEnabled(row, index, enabled) {
        let _self = this;
        _self.binderInfoDate = {};
        _self.binderInfoDate.id = row.id;
        _self.binderInfoDate.state = enabled;
        showLoading();
        _self.update();
      },
      //删除
      remove(row, index) {
        let _self = this;
        _self.search = {};
        _self.search.id = row.id;
        showLoading();
        _self.delete();
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getListAll()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getListAll()
      },
      //关闭弹出框
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.cancel();
          })
          .catch(_ => {
          });
      },
      //获取详情
      getBinderInfo() {
        let _self = this;
        let params = {
          id: _self.search.id,
        }
        getBinderInfo(params).then(response => {
          if (response.data.status == 100) {
            _self.binderInfoDate = response.data.results;
            _self.getBrandList();
            _self.getCategoryList();
            _self.getModelList();
            _self.getMateriaList();
          } else {
            this.$Message.error(error.message);
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //查询列表
      getListAll() {
        let _self = this;
        let params = {
          id: _self.search.id,
          materialId: _self.search.materialId,
          materialName: _self.search.materialName,
          modelId: _self.search.modelId,
          modelName: _self.search.modelName,
          categoryId: _self.search.categoryId,
          categoryName: _self.search.categoryName,
          code: _self.search.code,
          imie: _self.search.imie,
          state: _self.search.state,
          pageSize: _self.pages.pageSize,
          startRow: _self.pages.page,
        }
        getBinderAll(params).then(response => {
          if (response.data.status == 100) {
            _self.bindingList = response.data.results.list;
            _self.pages.total = response.data.results.total;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      choseBrand(e) {
        this.$forceUpdate();
        this.getCategoryList();
      },
      choseCategory(e) {
        this.$forceUpdate();
        this.getModelList();
      },
      // 选择型号
      choseModel() {
        this.$forceUpdate();
        this.getMateriaList();
      },
      choseMaterial(e) {
        this.$forceUpdate();
      },
      //机型品牌
      getBrandList() {
        selectAllBrand()
          .then(res => {
            if (res.data.status == 100) {
              this.brandList = res.data.results;
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
      },
      //机型品类
      getCategoryList() {
        this.categoryList = [];
        this.modelList = []; //清空型号数据
        let para = {
          brandId: this.binderInfoDate.brandId
        };
        selectCategory(para)
          .then(res => {
            if (res.data.status == 100) {
              this.categoryList = res.data.results;
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
      },
      //机型型号
      getModelList() {
        let para = {
          brandId: this.binderInfoDate.brandId,
          categoryId: this.binderInfoDate.categoryId
        };
        selectModel(para)
          .then(res => {
            if (res.data.status == 100) {
              this.modelList = res.data.results;
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
      },
      //机型物料
      getMateriaList() {
        let para = {
          brandId: this.binderInfoDate.brandId,
          categoryId: this.binderInfoDate.categoryId,
          modelId: this.binderInfoDate.modelId,
          colorId: this.binderInfoDate.colorId,
          startRow: 1,
          pageSize: 1000
        };
        selectMaterialManagements(para)
          .then(res => {
            if (res.data.status == 100) {
              this.materialFormList = res.data.results;
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.$Message.error(error.message);
          });
      },
      cancel(){
        let _self=this;
        _self.search={};
        _self.binderInfoDate={};
        _self.dialogFormVisible=false;
      },
      submit() {
        let _self = this;

        let code=_self.binderInfoDate.code;
        let imie=_self.binderInfoDate.imie;
        if (!code){
          this.$message({
            message: "序列号不允许为空",
            type: "error"
          });
          return;
        }
        if (!imie){
          this.$message({
            message: "识别码不允许为空",
            type: "error"
          });
          return;
        }
        showLoading();
        if (_self.addnew) {
          _self.add();
        } else {
          _self.update();
        }
      },
      add() {
        let _self = this;
        let params = {
          brandId: _self.binderInfoDate.brandId,
          categoryId: _self.binderInfoDate.categoryId,
          modelId: _self.binderInfoDate.modelId,
          materialId: _self.binderInfoDate.materialId,
          code: _self.binderInfoDate.code,
          imie: _self.binderInfoDate.imie,
          state: _self.binderInfoDate.state,
          memo: _self.binderInfoDate.memo,
        };
        addMaterialBinding(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            _self.binderInfoDate={};
            _self.search={};
            _self.getListAll();
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch(error => {
          hideLoading();
          this.$Message.error(error.message);
        });

      },
      update() {
        let _self = this;
        let params = {
          id: _self.binderInfoDate.id,
          memo: _self.binderInfoDate.memo,
          state: _self.binderInfoDate.state
        }
        updateBinding(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            _self.binderInfoDate={};
            _self.search={};
            _self.getListAll();
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch(error => {
          hideLoading();
          this.$Message.error(error.message);
        });
      },
      delete() {
        let _self = this;
        let params = {
          id: _self.search.id
        };
        deleteBinding(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.search={};
            _self.getListAll();
            _self.binderInfoDate = {};
          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch(error => {
          hideLoading();
          this.$Message.error(error.message);
        });
      },

    },

  }
</script>
<style lang="scss" scoped>
  .materialBinderList {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// materialSnBinderList.vue?72a7bfb3